import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import Deploy from '../../../edit/deploy'
import TemplateImageLoader from '~/pages/cp/automation/addNew/templateImageLoader.jsx'
import * as siteActions from '../../../../../../../../data/actions/siteActions'
import FormAutomate from '../../../automate'
import postHogFunctions from '~/Classes/posthog'
import axios from '~/data/http/axios'
import { consumeFormCreateReturnTo } from '~/pages/cp/forms/formCreateReturnTo'

@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class FormConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {},
            approveDrawer: null,
            account: null
        }
        this.next = this.next.bind(this)
    }

    componentDidMount() {
        axios.get('/accountMaster').then((res) => {
            this.setState({
                account: res.data.AccountMaster
            })
        })
    }

    sendToPosthog() {
        let formType = 'regular'
        if (this.props.form.options?.serve) formType = 'gated'
        postHogFunctions.capture('form_created', {
            type: formType,
            hosted: this.props.form.formType > 0
        })
    }

    next(skipRedirect) {
        this.props.form.wizard.step6 = true
        this.props.form.status = 1
        this.props.save()
        this.sendToPosthog()
        if (!skipRedirect) {
            var redirect =
                consumeFormCreateReturnTo() ||
                '/cp/groups/' + this.props.groupId + '/forms/edit/' + this.props.form.id
            this.props.history.push(redirect)
        }
    }

    save() {
        this.props.form.wizard.step6 = true
        this.props.save()
        this.sendToPosthog()
        this.props.history.push(
            consumeFormCreateReturnTo() || '/cp/groups/' + this.props.groupId + '/forms'
        )
    }

    activate() {
        var theDrawer = (
            <NewUserForm
                from='form'
                finish={() => {
                    this.setState({ approveDrawer: null })
                }}
            />
        )
        this.setState({ approveDrawer: theDrawer })
    }

    automate() {
        const drawerContent = (
            <FormAutomate
                formName={this.props.form.formName}
                GroupId={this.props.groupId}
                FormId={this.props.form.id}
                save={() => this.next(true)}
                edit={true}
            />
        )
        this.props.dispatch(siteActions.alterSiteDrawer(true, true, 'right', drawerContent, true, 500))
    }

    render() {
        if (!this.state.account) return <LoadingIcons />

        const approved = this.state.account.approved
        const doneNewUserQuestions = this.state.account.doneNewUserQuestions
        return (
            <div>
                <Row>
                    <Column xs={12} md={4} className='mar-b25'>
                        <div
                            className='campaign-thumbnail'
                            style={{ width: '100%', height: '100%', minHeight: '150px' }}
                        >
                            <TemplateImageLoader
                                imageUrl={this.props.screenshotUrl}
                                form={this.props.form.formType === 1}
                            />
                        </div>
                    </Column>
                    <Column xs={12} md={8}>
                        <Paper>
                            {approved ? (
                                <>
                                    <h4 className='mar-b25'>{i18n.t('form:step6.header')}</h4>
                                    <Deploy form={this.props.form} />
                                </>
                            ) : (
                                <>
                                    <h4 className='mar-b25'>{i18n.t('form:step6.header')}</h4>
                                    <div>Forms cannot be deployed until we have approved your account</div>
                                </>
                            )}
                        </Paper>
                    </Column>
                </Row>
                <div className='quickFlex end-xs'>
                    <Button
                        className='mar-r10'
                        iconRight={<Icons icon='lightning' />}
                        onClick={this.automate.bind(this)}
                    >
                        Automate
                    </Button>
                    {approved && (
                        <Button
                            iconRight={<Icons icon='arrowRight' />}
                            className='button-primary'
                            text={i18n.t('form:step6.finish')}
                            onClick={() => this.next()}
                        />
                    )}
                    {doneNewUserQuestions && !approved && (
                        <Button text='Save & Exit' onClick={this.save.bind(this)} />
                    )}
                    {!doneNewUserQuestions && (
                        <>
                            <div className='mar-r10 text-orange text-heavy'>
                                We must approve your account for you to use web forms
                            </div>
                            <Button
                                className='button-orange'
                                text='Request Approval'
                                onClick={this.activate.bind(this)}
                            />
                        </>
                    )}
                </div>
                {this.state.approveDrawer}
            </div>
        )
    }
}

export default FormConfirm
